import { useState, useCallback } from "react";
import { db } from "../services/firebase";
import { ref, set, push } from "firebase/database";

export default function useCreateDomain() {

    const [deletingDomain, setDeletingDomain] = useState(false);
    const [deletingDomainError, setDeletingDomainError] = useState(null);

    const deleteDomain = useCallback(async (domainId = null) => {

        try {
            setDeletingDomain(true);
            setDeletingDomainError(null);

            let domainRef = ref(db, `Domains/${domainId}`);

            await set(domainRef, null);

            return true;

        } catch (err) {
           
            setDeletingDomainError("Failed to delete domain");
            return false;

        } finally {
            setDeletingDomain(false);
        }
    }, []);

    return { deleteDomain, deletingDomain, deletingDomainError };
}
